export default __webpack_public_path__ + "static/media/jquery.27318f33.svg";